import React from 'react';
import { Helmet } from 'react-helmet';
import FooterBar from 'components/FooterBar';
import { Switch, Route, Redirect } from 'react-router-dom'
import BookingsReport from './BookingsReport';
import OccupancyReport from './OccupancyReport';
import DailyReconciliationReport from './DailyReconciliationReport';
import RevenueReport from './RevenueReport';
import PriceTableReport from './PriceTableReport';

const Reports = () => {

  return (
    <>
      <Helmet>
        <title>Reports - Rook Hotel PMS</title>
        <meta name="description" content="Reports - Rook Hotel PMS" />
      </Helmet>
      <div style={{marginTop: "50px"}}>
        <Switch>
          <Route
            path={'/reports/bookings'}
            render={() => <BookingsReport />}
          />
          <Route
            path={'/reports/occupancy'}
            render={() => <OccupancyReport />}
          />
          <Route
            path={'/reports/daily-reconciliation'}
            render={() => <DailyReconciliationReport />}
          />
          <Route
            path={'/reports/revenue'}
            render={() => <RevenueReport />}
          />
          <Route
            path={'/reports/price-table'}
            render={() => <PriceTableReport />}
          />
          <Redirect to={'/reports'} />
        </Switch>
      </div>
      <FooterBar />
    </>
  );
};

export default Reports;